module.exports = __webpack_public_path__ + "static/media/replay-arrow-white.690269b1.svg";